import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axiosClient from "../../libs/axiosClient";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import styles from "./ResetPw.module.scss";

function ResetPw() {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [resetToken, setResetToken] = useState<string | null>(null);
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get("token");

    if (!token) {
      alert(t("resetPw.tokenMissingError"));
      navigate("/findAccount");
    } else {
      setResetToken(token);
    }
  }, [location.search, navigate, t]);

  const isFormValid = () => {
    return password.trim() !== "" && confirmPassword.trim() !== "";
  };

  const handlePasswordReset = async () => {
    if (!isFormValid()) {
      setError(t("resetPw.emptyFieldsError"));
      return;
    }

    if (password !== confirmPassword) {
      setError(t("resetPw.confirmPlaceholder"));
      return;
    }

    try {
      if (!resetToken) {
        alert(t("resetPw.errorAlert"));
        return;
      }

      await axiosClient.post("/api/v1/auth/reset-pw", {
        token: resetToken,
        password,
        password_confirm: confirmPassword,
      });
      alert(t("resetPw.successMessage"));
      navigate("/login");
    } catch (error: any) {
      console.error("Error resetting password:", error);
      setError(error.response?.data?.message || t("resetPw.errorAlert"));
    }
  };

  return (
    <>
      <Header selectedTab="none" onTabChange={() => {}} />
      <div className={styles.container}>
        <h3>{t("resetPw.title")}</h3>
        <div className={styles.formGroup}>
          <label>{t("resetPw.newPw")}</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder={t("resetPw.newPwPlaceholder")}
          />
        </div>
        <div className={styles.formGroup}>
          <label>{t("resetPw.confirmNewPw")}</label>
          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder={t("resetPw.confirmPlaceholder")}
          />
        </div>
        {error && <p className={styles.errorText}>{error}</p>}
        <button
          className={`${styles.submitButton} ${isFormValid() ? styles.active : ""}`}
          disabled={!isFormValid()}
          onClick={handlePasswordReset}
        >
          {t("resetPw.buttonText")}
        </button>
      </div>
      <Footer />
    </>
  );
}

export default ResetPw;
